import {
  Button,
  Content,
  FillIcon,
  Flex,
  Skeleton,
  SkeletonGroup,
  StrokeIcon,
} from '@acsbe/ui';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  APPLICATION_MODES,
  useApplicationViewState,
  useDomainSelection,
  useMerchantSession,
} from '../../context';
import { ChooseAPlanAction } from '../root/subscription/choose-plan-button';

const WidgetStatusBadge = () => {
  const { applicationMode } = useApplicationViewState();
  const { merchantDetails, toggleScript } = useMerchantSession();
  const { licenseDetails } = useDomainSelection();

  const [showStatusAsEnabled, setShowStatusAsEnabled] = useState<
    boolean | null
  >(null);
  const [maskingStatus, setMaskingStatus] = useState(false);

  useEffect(() => {
    if (
      !merchantDetails ||
      !licenseDetails ||
      merchantDetails?.widgetStatus === undefined
    ) {
      return;
    }

    if (
      licenseDetails &&
      (licenseDetails.status === 'expired' ||
        licenseDetails.status === 'archived')
    ) {
      setShowStatusAsEnabled(false);
      setMaskingStatus(true);
    } else {
      setShowStatusAsEnabled(merchantDetails?.widgetStatus === true);
    }
  }, [licenseDetails, merchantDetails, merchantDetails?.widgetStatus]);

  if (showStatusAsEnabled === null) {
    return (
      <SkeletonGroup label="Loading...">
        <Skeleton width="200px" height="24px" />
      </SkeletonGroup>
    );
  }

  return (
    <Flex
      row
      style={{
        backgroundColor: showStatusAsEnabled ? '#E6F4E7' : '#F2F6FF',
        padding: '8px 16px 8px 12px',
        borderRadius: '8px',
        gap: '8px',
        alignItems: 'center',
      }}
    >
      <FillIcon
        name={showStatusAsEnabled ? 'CheckWithCircle' : 'Warning'}
        size={24}
        style={{ color: showStatusAsEnabled ? '#078912' : '#D8161F' }}
      />
      <Content style={{ fontWeight: 600 }}>
        {showStatusAsEnabled ? 'accessWidget is on' : 'accessWidget is off'}
      </Content>

      {showStatusAsEnabled ||
      applicationMode === APPLICATION_MODES.LIMITED ? null : maskingStatus ? (
        <InlineButton
          variant="link"
          size="lg"
          scale="primary"
          data-mixpanel="choose-a-plan-link"
          style={{ padding: '8px 12px' }}
          onClick={ChooseAPlanAction}
        >
          <Flex row gap={2} justify="center">
            Choose a plan <StrokeIcon name="ArrowRight" />
          </Flex>
        </InlineButton>
      ) : (
        <InlineButton
          variant="link"
          size="lg"
          scale="primary"
          data-mixpanel="turn-on-widget-link"
          style={{ padding: '8px 12px' }}
          onClick={() => {
            toggleScript(true);
          }}
        >
          <Flex row gap={2} justify="center">
            Turn on <StrokeIcon name="ArrowRight" />
          </Flex>
        </InlineButton>
      )}
    </Flex>
  );
};

const InlineButton = styled(Button)`
  display: inline-block;
`;

export { WidgetStatusBadge };
